import { Injectable } from '@angular/core';

import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DialogMessageData } from 'sc-common/shared/dialog-message/dialog-message-data';
import { DialogMessageComponent } from 'sc-common/shared/dialog-message/dialog-message.component';

@Injectable(
    {
        providedIn: 'root'
    })
export class DialogMessageService {

    constructor(private readonly _dialogService: DialogService) { }

    public showMessage(messageData: DialogMessageData): DynamicDialogRef {

        const data = new DialogMessageData();

        Object.assign(data, messageData);

        return this._dialogService.open(DialogMessageComponent, {
            width: data.width,
            header: data.header,
            closable: true,
            data: data
        });
    }

    public showMessages(messageData: DialogMessageData): DynamicDialogRef {

        const data = new DialogMessageData();

        Object.assign(data, messageData);

        return this._dialogService.open(DialogMessageComponent, {
            width: data.width || '30vw',
            header: data.header,
            closable: true,
            data: data
        });
    }
}
